import { Button, Typography, Hidden } from '@mui/material';

import Grid from 'components/core/Grid';
import { listPropertyOnboardingImage } from 'config/imageUrls';
import { useListPageModalNavigation } from '../modal/hooks/useListPageModalNavigation';

import { ContentSection, CircleBullet } from './styles';

const BulletListItem = ({ number, title, description }: { number: number; title: string; description: string }) => {
  return (
    <>
      <Typography variant="h3" mt={4} mb={1}>
        <CircleBullet>{number}</CircleBullet> {title}
      </Typography>
      <Typography>{description}</Typography>
    </>
  );
};

const items = [
  {
    title: 'Tell us about your property',
    description:
      'Using the step-by-step listing wizard, provide details about your property including where it is located, how many bedrooms and bathrooms it has, amenities that are available etc.',
  },
  {
    title: 'Define policies, availability & rates',
    description:
      'Define house rules and booking policies that all guests must agree to before they can stay at your property. Set which dates are available for guests to reserve and the nightly rate.',
  },
  {
    title: 'Host great guests from around the world',
    description:
      'As soon as your listing has been reviewed and activated, begin to invite our high-quality, respectful vacation rental guests from around the world into your property.',
  },
];

export const GetListed24Hours = ({ openModal }: { openModal: () => void }) => {
  const { pushUnassistedUrl } = useListPageModalNavigation();
  const onClick = () => {
    pushUnassistedUrl();
    openModal();
  };
  return (
    <>
      <ContentSection>
        <Grid container spacing={4}>
          <Hidden only="sm">
            <Grid item xs={12} md={5}>
              <img src={listPropertyOnboardingImage} width="100%" />
            </Grid>
          </Hidden>
          <Grid item xs={12} md={7}>
            <Typography variant="h2">Get Listed Within 24 Hours</Typography>
            {items.map((item, index) => (
              <BulletListItem key={item.title + index} {...item} number={index + 1} />
            ))}
            <br />
            <Button variant="contained" color="secondary" fullWidth onClick={onClick}>
              Click Here to Get Started
            </Button>
          </Grid>
        </Grid>
      </ContentSection>
    </>
  );
};
